"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useProductBoxConfiguration = void 0;
var _checkoutUtils = require("@ori/checkout-utils");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _presentationHttp = require("@ori/presentation-http");
var _staticApiClientReact = require("@ori/static-api-client-react");
const useProductBoxConfiguration = ()=>{
    const { tenant } = (0, _environment.useEnvironment)();
    const { language } = (0, _i18n.useLanguage)();
    const { customerTypeId, loading: loadingSegmentationParameters } = (0, _presentationHttp.useUserSegmentationData)();
    const { data } = (0, _staticApiClientReact.useGetTenantApplicationsProductboxConfiguration)(tenant, {
        customerTypeId: customerTypeId !== null && customerTypeId !== void 0 ? customerTypeId : undefined,
        lang: language
    }, {
        swr: {
            ...(0, _checkoutUtils.getRetryErrorSwrOptions)(),
            enabled: !loadingSegmentationParameters
        }
    });
    return data;
};
exports.useProductBoxConfiguration = useProductBoxConfiguration;
